import './Main.css';

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

//import loan from '../Images/loan.png';
//import memberShip from '../Images/memberShip.png';
//import travel from '../Images/travel.png';
//import Insurance from '../Images/Insurance.png';
//import contact from '../Images/contact.jpg';
import http from "../Services/httpService";
import service from "../Services/services";
import config from "../config.json";
import { toast } from "react-toastify";
import ConfirmDialog from './ConfirmDialog';
//import loanLogo from '../Images/loanLogo.png';

export default function Main() {
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [dataUser, setDataUser] = useState({
    id: 0,
    name: "",
    family: ""
  });

  const [ozveSetting, setOzveSetting] = useState({ vam: "" });
  const [isLoadingSetting, setIsLoadingSetting] = useState(false);
  const [mode, setMode] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [inRequestLoan, setInRequestLoan] = useState(false);

  const [showInsuranceCancel, setShowInsuranceCancel] = useState(false);
  const [inInsuranceCancel, setInInsuranceCancel] = useState(false);

  const [showInsuranceGold, setShowInsuranceGold] = useState(false);
  const [inInsuranceGold, setInInsuranceGold] = useState(false);

  const [showInsuranceGoldCancel, setShowInsuranceGoldCancel] = useState(false);
  const [inInsuranceGoldCancel, setInInsuranceGoldCancel] = useState(false);

  const loadData = async () => {
    setIsLoading(true);

    try {
      const { data } = await service.OzveGet();
      setIsLoading(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      setDataUser(data.payload);
      setShowLoading(0);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const getSetting = async () => {
    setIsLoadingSetting(true);

    try {
      const { data } = await service.SettingGet();
      setIsLoadingSetting(false);

      /*if (data.errorCode != 0) {
        toast.error(data.message, { theme: "colored" });
        return
      }*/

      setOzveSetting(data);
      //method();
      setShowModal(true);
    } catch (err) {
      setIsLoadingSetting(false);
    }
  };

  useEffect(() => {
    const jwt = http.getLocalJwt();

    if (!jwt || jwt === "") {
      navigate('/login');
      return;
    }

    loadData();
  }, []);

  const logout = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    http.logout();
    http.goLogin();
  };

  const sendRequestLoan = async () => {
    setInRequestLoan(true);

    try {
      const { data } = await service.RequestLoan();
      setInRequestLoan(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      setShowModal(false);
      toast.dark('درخواست شما ثبت شد');
    } catch (err) {
      setInRequestLoan(false);
    }
  };

  const sendRequestTravel = async () => {
    setInRequestLoan(true);

    try {
      const { data } = await service.RequestTravel();
      setInRequestLoan(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      setShowModal(false);
      toast.dark('درخواست شما ثبت شد');
    } catch (err) {
      setInRequestLoan(false);
    }
  };

  const doPayment = async (mode) => {
    setInRequestLoan(true);

    try {
      const { data } = await service.Payment(mode);
      setInRequestLoan(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      //toast.dark('درخواست شما ثبت شد')
      toast.dark('لطفا تا انتقال به درگاه بانک شکیبا باشید');
      window.location = data.payload;
      //window.open(data.payload,'_self');//'_blank');
    } catch (err) {
      setInRequestLoan(false);
    }
  };

  const doInsuranceCancel = async () => {
    setInInsuranceCancel(true);

    try {
      const { data } = await service.RequestInsuranceCancel();
      setInInsuranceCancel(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      toast.dark('درخواست انصراف از بیمه تکمیلی ثبت شد');
      setShowInsuranceCancel(false);
    } catch (err) {
      setInInsuranceCancel(false);
    }
  };

  const doInsuranceGold = async () => {
    setInInsuranceGold(true);

    try {
      const { data } = await service.RequestInsuranceGold();
      setInInsuranceGold(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      toast.dark('درخواست شما ثبت شد');
      setShowInsuranceGold(false);
    } catch (err) {
      setInInsuranceGold(false);
    }
  };

  const doInsuranceGoldCancel = async () => {
    setInInsuranceGoldCancel(true);

    try {
      // اگر نام متد API شما متفاوت است، این نام را با متد صحیح جایگزین کنید.
      const { data } = await service.RequestInsuranceGoldCancel();

      setInInsuranceGoldCancel(false);

      if (data.errorCode !== 0) {
        toast.error(data.message, { theme: "colored" });
        return;
      }

      toast.dark('درخواست انصراف از بیمه طلایی ثبت شد');
      setShowInsuranceGoldCancel(false);
    } catch (err) {
      setInInsuranceGoldCancel(false);
    }
  };

  // آرایه منوها با آیکون‌های متناسب یونیکد و استایل واضح‌تر برای بخش‌های انصراف
  const menuItems = [
    {
      title: 'مشخصات شما',
      iconUnicode: '👤',
      iconBg: 'bg-primary-subtle text-primary border border-primary-subtle',
      to: '/personData',
      description: 'مشاهده و بررسی اطلاعات عضویت'
    },
    {
      title: 'درخواست وام',
      iconUnicode: '💵',
      iconBg: 'bg-success-subtle text-success border border-success-subtle',
      action: () => {
        if (isLoadingSetting) return;
        setMode('lean');
        getSetting();
      },
      loading: isLoadingSetting,
      description: 'ثبت درخواست وام قرض‌الحسنه'
    },
    {
      title: 'ثبت نام سفر',
      iconUnicode: '🧳',
      iconBg: 'bg-info-subtle text-info border border-info-subtle',
      action: () => {
        if (isLoadingSetting) return;
        setMode('travel');
        getSetting();
      },
      loading: isLoadingSetting,
      description: 'مشاهده و ثبت درخواست سفر زیارتی/سیاحتی'
    },
    {
      title: 'بیمه تکمیلی',
      iconUnicode: '🩺',
      iconBg: 'bg-primary-subtle text-primary border border-primary-subtle',
      to: '/RequestInsurance',
      description: 'اطلاعات و درخواست بیمه تکمیلی درمان'
    },
    {
      title: 'انصراف بیمه تکمیلی',
      iconUnicode: '🚫',
      iconBg: 'bg-danger-subtle text-danger border border-danger',
      cardBorder: 'border-danger-subtle',
      badge: 'انصراف',
      action: () => setShowInsuranceCancel(true),
      description: 'لغو و ثبت درخواست انصراف بیمه تکمیلی'
    },
    {
      title: 'درخواست بیمه طلایی',
      iconUnicode: '🌟',
      iconBg: 'bg-warning-subtle text-warning border border-warning-subtle',
      action: () => setShowInsuranceGold(true),
      description: 'ثبت درخواست و عضویت در بیمه طلایی'
    },
    {
      title: 'انصراف از بیمه طلایی',
      iconUnicode: '❌',
      iconBg: 'bg-danger-subtle text-danger border border-danger',
      cardBorder: 'border-danger-subtle',
      badge: 'انصراف',
      action: () => setShowInsuranceGoldCancel(true),
      description: 'لغو و ثبت درخواست انصراف بیمه طلایی'
    }
  ];

  const renderMenuItem = (item) => {
    const cardContent = (
      <div className={`card h-100 shadow-sm rounded-4 text-decoration-none bg-white p-3 d-flex flex-row align-items-center justify-content-between position-relative overflow-hidden ${item.cardBorder || 'border-0'}`}>
        {/* نوار رنگی کناری برای گزینه‌های انصراف جهت تشخیص فوری */}
        {item.badge && (
          <div className="position-absolute top-0 start-0 h-100 bg-danger" style={{ width: '4px' }}></div>
        )}

        <div className="d-flex align-items-center gap-3">
          {/* باکس آیکون یونیکد */}
          <div 
            className={`rounded-3 ${item.iconBg || 'bg-light'} d-flex align-items-center justify-content-center shadow-sm fs-2`} 
            style={{ width: '56px', height: '56px', flexShrink: 0 }}
          >
            <span aria-hidden="true">{item.iconUnicode}</span>
          </div>

          <div className="text-end">
            <div className="d-flex align-items-center gap-2">
              <h6 className="fw-bold mb-1 text-dark fs-6">{item.title}</h6>
              {item.badge && (
                <span className="badge bg-danger-subtle text-danger border border-danger-subtle rounded-pill small" style={{ fontSize: '0.7rem' }}>
                  {item.badge}
                </span>
              )}
            </div>
            <p className="text-secondary small mb-0">{item.description}</p>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2 ps-2">
          {item.loading && (
            <span className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">در حال بارگذاری...</span>
            </span>
          )}
          <span className="text-muted fs-5" aria-hidden="true">‹</span>
        </div>
      </div>
    );

    if (item.to) {
      return (
        <div className="col-12 col-md-6" key={item.title}>
          <Link
            to={item.to}
            className="text-decoration-none d-block h-100"
          >
            {cardContent}
          </Link>
        </div>
      );
    }

    return (
      <div className="col-12 col-md-6" key={item.title}>
        <button
          type="button"
          onClick={item.action}
          className="btn p-0 border-0 w-100 text-start h-100 bg-transparent"
          disabled={item.loading}
        >
          {cardContent}
        </button>
      </div>
    );
  };

  return (
    <main className="container-fluid bg-light min-vh-100 py-3 py-md-4" dir="rtl">
      {/* دیالوگ ثبت درخواست بیمه طلایی */}
      <ConfirmDialog
        show={showInsuranceGold}
        title="🌟 ثبت درخواست بیمه طلایی"
        handleDo={doInsuranceGold}
        handleCancel={() => setShowInsuranceGold(false)}
        isBusy={inInsuranceGold}
      >
        <div className="row mt-3">
          <div className="col">
            <div className="alert alert-warning mb-0 d-flex align-items-center gap-2">
              <span className="fs-4">⚠️</span>
              <span>آیا از ثبت درخواست بیمه طلایی اطمینان دارید؟</span>
            </div>
          </div>
        </div>
      </ConfirmDialog>

      {/* دیالوگ انصراف از بیمه تکمیلی */}
      <ConfirmDialog
        show={showInsuranceCancel}
        title="🚫 ثبت درخواست انصراف از بیمه تکمیلی"
        handleDo={doInsuranceCancel}
        handleCancel={() => setShowInsuranceCancel(false)}
        isBusy={inInsuranceCancel}
      >
        <div className="row mt-3">
          <div className="col">
            <div className="alert alert-danger mb-0 d-flex align-items-center gap-2">
              <span className="fs-4">🛑</span>
              <span>آیا از انصراف و لغو بیمه تکمیلی اطمینان کامل دارید؟</span>
            </div>
          </div>
        </div>
      </ConfirmDialog>

      {/* دیالوگ انصراف از بیمه طلایی */}
      <ConfirmDialog
        show={showInsuranceGoldCancel}
        title="❌ ثبت درخواست انصراف از بیمه طلایی"
        handleDo={doInsuranceGoldCancel}
        handleCancel={() => setShowInsuranceGoldCancel(false)}
        isBusy={inInsuranceGoldCancel}
      >
        <div className="row mt-3">
          <div className="col">
            <div className="alert alert-danger mb-0 d-flex align-items-center gap-2">
              <span className="fs-4">🛑</span>
              <span>آیا از انصراف و لغو بیمه طلایی اطمینان کامل دارید؟</span>
            </div>
          </div>
        </div>
      </ConfirmDialog>

      {/* دیالوگ درخواست وام یا سفر */}
      <ConfirmDialog
        show={showModal}
        size="xl"
        title="📋 ثبت درخواست"
        handleDo={() => {
          mode === "lean" ? sendRequestLoan() : sendRequestTravel();
        }}
        handleCancel={() => setShowModal(false)}
        isBusy={inRequestLoan}
      >
        <div className="row mt-3 align-items-center">
          <div className="col-auto">
            <div className="rounded-3 bg-light p-3 d-flex align-items-center justify-content-center border shadow-sm fs-1" style={{ width: '70px', height: '70px' }}>
              <span aria-hidden="true">{mode === "lean" ? "💵" : "🧳"}</span>
            </div>
          </div>
          <div className="col fs-5 fw-semibold text-dark">
            {mode === "lean" ? ozveSetting.vam : ozveSetting.safar}
          </div>
        </div>
      </ConfirmDialog>

      <div className="container" style={{ maxWidth: '960px' }}>
        
        {/* هدر صفحه */}
        <header className="card shadow-sm border-0 rounded-4 p-3 p-md-4 mb-4 bg-white">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <span className="badge bg-primary-subtle text-primary mb-2 px-3 py-1 rounded-pill small fw-semibold">
                پنل خدمات اعضا
              </span>
              <h1 className="h4 fw-bold text-dark mb-1">🏛️ داشبورد عضویت</h1>
              <p className="text-secondary small mb-0">خدمات و اطلاعات عضویت خود را از این بخش مدیریت کنید.</p>
            </div>
            <span className="fs-2 text-primary opacity-75 d-none d-sm-block" aria-hidden="true">✦</span>
          </div>
        </header>

        {/* کارت پروفایل کاربر */}
        <section className="card shadow-sm border-0 rounded-4 p-3 p-md-4 mb-4 bg-white" aria-label="اطلاعات عضو">
          <div className="row g-3 align-items-center">
            
            <div className="col-12 col-md-auto text-center text-md-start">
              <div className="position-relative d-inline-block">
                {showLoading !== 1 && (
                  <img
                    src={`${config.apiUrl}/picture/${dataUser.id}.jpg?${Date.now()}`}
                    // src={`${config.apiUrl}/api/kanon/WebOzve/GetPic?id=${dataUser.id}&${new Date().getTime()}`}
                    className="rounded-circle border border-3 border-light shadow-sm object-fit-cover"
                    style={{ width: '90px', height: '90px' }}
                    alt={`تصویر ${dataUser.name || ''} ${dataUser.family || ''}`}
                    id="picProfile"
                    onLoad={() => setShowLoading(2)}
                    onError={(e) => {
                      console.log('error', e);
                      setShowLoading(1);
                    }}
                  />
                )}

                {(showLoading === 0 || showLoading === 1) && (
                  <div 
                    className="rounded-circle border border-3 border-light shadow-sm bg-light d-flex align-items-center justify-content-center text-secondary fs-1"
                    style={{ width: '90px', height: '90px' }}
                    id="picProfileFallback"
                  >
                    👤
                  </div>
                )}
              </div>
            </div>

            <div className="col-12 col-md">
              <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-start gap-2 mb-2">
                <h2 className="h5 fw-bold mb-0 text-dark">
                  {dataUser.name} {dataUser.family}
                </h2>
                <span className="badge bg-success-subtle text-success border border-success-subtle rounded-pill small px-2">
                  ● عضو سامانه
                </span>
              </div>

              <div className="row g-2 justify-content-center justify-content-md-start small text-secondary mb-3">
                <div className="col-auto">
                  <span className="bg-light px-2 py-1 rounded border">
                    🪪 کد ملی: <strong className="text-dark">{dataUser.codeMeli || '—'}</strong>
                  </span>
                </div>
                <div className="col-auto">
                  <span className="bg-light px-2 py-1 rounded border">
                    📅 اعتبار: <strong className="text-primary">{dataUser.cardExpire || '—'}</strong>
                  </span>
                </div>
              </div>

              <div className="text-center text-md-start">
                <Link 
                  to="/" 
                  onClick={logout} 
                  className="btn btn-outline-danger btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-2 text-decoration-none"
                >
                  <span aria-hidden="true">🚪</span>
                  <span>خروج از حساب</span>
                  {isLoading && (
                    <span className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">در حال بارگذاری...</span>
                    </span>
                  )}
                </Link>
              </div>
            </div>

            {/* ارقام و شماره‌های عضویت */}
            <div className="col-12 col-md-auto border-top border-md-top-0 border-md-start pt-3 pt-md-0 ps-md-4">
              <div className="row g-2 text-center text-md-end">
                <div className="col-6 col-md-12">
                  <div className="bg-light p-2 rounded-3 border">
                    <span className="d-block small text-muted">شماره مستمری</span>
                    <strong className="text-dark fs-6">{dataUser.mostamariCode || '—'}</strong>
                  </div>
                </div>
                <div className="col-6 col-md-12">
                  <div className="bg-light p-2 rounded-3 border">
                    <span className="d-block small text-muted">شماره عضویت</span>
                    <strong className="text-primary fs-6">{dataUser.number || '—'}</strong>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* بخش لیست خدمات */}
        <section aria-label="خدمات قابل دسترس">
          <div className="d-flex align-items-center justify-content-between mb-3 px-1">
            <div>
              <h2 className="h5 fw-bold text-dark mb-1">خدمات قابل دسترس</h2>
              <p className="text-secondary small mb-0">برای ادامه، یکی از گزینه‌های زیر را انتخاب کنید.</p>
            </div>
            <span className="text-muted fs-4" aria-hidden="true">☷</span>
          </div>

          <div className="row g-3">
            {menuItems.map(renderMenuItem)}
          </div>
        </section>

        {/* <Link
          onClick={e=>{
            e.preventDefault();
            e.stopPropagation()
            doPayment(1);
          }}
          to="/sendMedia"
          className='col-3 mb-3 text-dark text-decoration-none p-3 mx-2 shadow bg-light rounded'>

          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              <img src={payment} className='thumbnail img-responsive imgMenu' />
            </div>
          </div>
          <div className="row">
            <div className='col p-0 d-flex align-items-center justify-content-center'>
              پرداخت حق عضویت
            </div>
          </div>
        </Link>
        */}
      </div>
    </main>
  );
}
